import React from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import AddFundPageOne from "./component/AddFundPageOne";

export default function AddFunDashboard() {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        {/* Relative paths */}
        <Route path="" element={<AddFundPageOne />} />       {/* /add-fund */}
       
      </Routes>
    </AnimatePresence>
  );
}